import {
  SemiCircleProgressProps as MantineSemiCircleProgressProps,
  SemiCircleProgress as MantineSemiCircleProgress,
} from '@mantine/core';

export type SemiCircleProgressProps = MantineSemiCircleProgressProps;

export const SemiCircleProgress = MantineSemiCircleProgress;

SemiCircleProgress.displayName = 'SemiCircleProgress';
